import { useMemo } from "react";

const useHeatmap = (apiHeatmapData) => {
  const matrix = useMemo(() => {
    const emptyMatrix = Array(7)
      .fill(null)
      .map(() => Array(24).fill(0));

    if (apiHeatmapData && apiHeatmapData.length > 0) {
      apiHeatmapData.forEach(({ day_of_week, hour_of_day, total_calls }) => {
        emptyMatrix[day_of_week][hour_of_day] = total_calls;
      });
    }

    return emptyMatrix;
  }, [apiHeatmapData]);

  const metadata = useMemo(() => {
    if (!apiHeatmapData || apiHeatmapData.length === 0) {
      return {
        maxCalls: 0,
        minCalls: 0,
        percentile75: 0,
        percentile50: 0,
        percentile25: 0,
      };
    }

    const values = apiHeatmapData.map((item) => item.total_calls).sort((a, b) => a - b);

    return {
      maxCalls: Math.max(...values),
      minCalls: Math.min(...values),
      percentile75: values[Math.floor(values.length * 0.75)] || 0,
      percentile50: values[Math.floor(values.length * 0.5)] || 0,
      percentile25: values[Math.floor(values.length * 0.25)] || 0,
    };
  }, [apiHeatmapData]);

  const days = useMemo(() => ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], []);

  const hours = useMemo(() => {
    const labels = [];
    for (let i = 0; i < 24; i++) {
      if (i === 0) labels.push("12 AM");
      else if (i < 12) labels.push(i.toString());
      else if (i === 12) labels.push("12 PM");
      else labels.push((i - 12).toString());
    }
    return labels;
  }, []);

  const getCellColor = useMemo(() => {
    return (value) => {
      if (value === 0) return "bg-[#EBE9FE] dark:bg-[#22262F]";

      const { maxCalls, percentile75, percentile50, percentile25 } = metadata;

      if (maxCalls === 0) return "bg-[#EBE9FE]";

      if (value <= percentile25) return "bg-[#D8D2FB] dark:bg-[#3d3466]";
      if (value <= percentile50) return "bg-[#9B8AFB] dark:bg-[#5c4a99]";
      if (value <= percentile75) return "bg-[#6C5DD3] dark:bg-[#7b68cc]";
      return "bg-[#3E1C96] dark:bg-[#9B8AFB]";
    };
  }, [metadata]);

  return {
    matrix,
    metadata,
    days,
    hours,
    getCellColor,
  };
};

export default useHeatmap;
